<script setup>
    defineProps({
        buttonText: {
            type: String,
            default: '',
        }
    })

    const emit = defineEmits(
        [
            'clickAction'
        ]
    )
</script>

<template>
    <button class="btn-search"
            @click.prevent="emit('clickAction', {})"
            @keydown.enter.prevent="emit('clickAction', {})" >
                <span class="search-inner">
                    <span class="circle" />
                    <span class="line-1" />
                    <span class="line-2" />
                </span>
        <span v-html="buttonText"/>
    </button>
</template>

<style lang="scss" scoped>

</style>
